import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/modules/common/services/shared-service';
import { AgendaPopupComponent } from './agenda-popup/agenda-popup.component';
import { ReunionPopupComponent } from './reunion-popup/reunion-popup.component';
import { RevisionPopupComponent } from './revision-popup/revision-popup.component';
import { VisitaDeEmpresaPopupComponent } from './visita-de-empresa-popup/visita-de-empresa-popup.component';
import { CheckedCheckBox } from '../models/Registro/CheckedCheckBox';
import { CompanyRegistro } from '../models/Registro/CompanyRegistro';
import { RegistroService } from '../../services/registro.service';
import { CompanySideBarTreeViewService } from '../../services/company-side-bar-tree-view.service';
import Utils from 'app/Utils';

@Component({
    selector: 'app-register-tab',
    templateUrl: './register-tab.component.html',
    styleUrls: ['./register-tab.component.scss'],
    standalone: false
})

export class RegisterTabComponent implements OnInit {
  @Input() companyId : any
  private cb: CheckedCheckBox
  public selectedCompanyId; 
  private currentUser: any
  private permissionList: string[];
  public checkBoxDefaultValues = true
  public hasVisitaViewAndEditPermission = false
  public hasVisitaDeletePermission = false
  public registerList: CompanyRegistro[]

  constructor(
    private _dialog: MatDialog,
    private _registroService: RegistroService,
    private _sharedService: SharedService
  ) {
    //initial values
    this.cb = new CheckedCheckBox("A","V","M","R");    
  }

  ngOnInit(): void {    
    this.selectedCompanyId = this.companyId 
    this.GetAllRegistroByTypes(this.selectedCompanyId, this.cb.Agenda, this.cb.VisitasDeEmpresa, this.cb.ReunionesConSME, this.cb.Revisiones)
 
    this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
    if (this.currentUser) {      
      this.permissionList = this._sharedService.getCurrentUserPermissions();
      this.VisitiaPermission()
    }    
  
  }


  public VisitiaPermission()
  {   
    this.hasVisitaViewAndEditPermission = this.permissionList.includes('10')
    this.hasVisitaDeletePermission = this.permissionList.includes('11')
  }

  public AddOrEdit(type: string, registro) {
    //popup is openned according to the type selected
    //A="Agenda",V="VisitasDeEmpresa",M="ReunionesConSME",R="Revisiones"
    switch (type) {
      case "A":
        {
          const dialogRef = this._dialog.open(AgendaPopupComponent, {
            data:
            {
              data: registro,
              companyId: Number(this.selectedCompanyId)
            }
          });

          dialogRef.afterClosed().subscribe(response => {            
            if (response) {
              this.GetAllRegistroByTypes(this.selectedCompanyId, this.cb.Agenda, this.cb.VisitasDeEmpresa, this.cb.ReunionesConSME, this.cb.Revisiones)
            }
          });

          break;
        }
      case "V":
        {
          const dialogRef = this._dialog.open(VisitaDeEmpresaPopupComponent, {
            data:
            {
              data: registro,
              companyId: Number(this.selectedCompanyId),
              user: this.currentUser.abreviacion.toUpperCase()
            }
          });
          dialogRef.afterClosed().subscribe(response => {
            if (response) {
              this.GetAllRegistroByTypes(this.selectedCompanyId, this.cb.Agenda, this.cb.VisitasDeEmpresa, this.cb.ReunionesConSME, this.cb.Revisiones)
            }
          });
          break;
        }
      case "M":
        {
          const dialogRef = this._dialog.open(ReunionPopupComponent, {
            data:
            {
              id: registro==null? null : registro.id,
              companyId: Number(this.selectedCompanyId),
              user: this.currentUser.abreviacion.toUpperCase()
            }
          });
          dialogRef.afterClosed().subscribe(response => {
            if (response) {
              this.GetAllRegistroByTypes(this.selectedCompanyId, this.cb.Agenda, this.cb.VisitasDeEmpresa, this.cb.ReunionesConSME, this.cb.Revisiones)
            }
          });
          break;
        }
      case "R":
        {
          const dialogRef = this._dialog.open(RevisionPopupComponent, {
            data:
            {
              data: registro,
              companyId: Number(this.selectedCompanyId),
              user: this.currentUser.abreviacion.toUpperCase()
            }
          });
          dialogRef.afterClosed().subscribe(response => {
            if (response) {
              this.GetAllRegistroByTypes(this.selectedCompanyId, this.cb.Agenda, this.cb.VisitasDeEmpresa, this.cb.ReunionesConSME, this.cb.Revisiones)
            }
          });
          break;
        }
    }
  }

  ChangeSelection(type: string, event) {
    //A,V,M,R values are expected from the API to filter data from type
    switch (type) {
      case "A":
        {
          event.checked ? this.cb.Agenda = type : this.cb.Agenda = null
          break;
        }
      case "V":
        {
          event.checked ? this.cb.VisitasDeEmpresa = type : this.cb.VisitasDeEmpresa = null
          break;
        }
      case "M":
        {
          event.checked ? this.cb.ReunionesConSME = type : this.cb.ReunionesConSME = null
          break;
        }
      case "R":
        {
          event.checked ? this.cb.Revisiones = type : this.cb.Revisiones = null
          break;
        }
    }
    this.GetAllRegistroByTypes(this.selectedCompanyId, this.cb.Agenda, this.cb.VisitasDeEmpresa, this.cb.ReunionesConSME, this.cb.Revisiones)
  }
  private GetAllRegistroByTypes(companyId: string, agenda: string, visitasDeEmpresa: string, reunionesConSME: string, revisiones: string) {
    //check if selected company has a value and any of the checkbox is checked using its object values
    //if (companyId !== undefined && agenda != null || visitasDeEmpresa != null || reunionesConSME != null || revisiones != null) {
   if(companyId != undefined && (agenda != null || visitasDeEmpresa != null || reunionesConSME != null || revisiones != null)){
      this._registroService.GetAllRegistroByTypes(companyId, agenda, reunionesConSME, revisiones, visitasDeEmpresa)
        .subscribe(res => {
          this.registerList = res.result;
        });
    }
    else {
      this.registerList = null
    }
  }
  public DeleteRegistro(index: number, id: number, type: string) {
    const dialogData = new ConfirmDialogModel('¿Eliminar registro?', '');
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this._registroService.DeleteRegistro(id, type).subscribe(result => {
          if (result) {
            this.registerList.splice(index, 1);
            this._sharedService.ShowSnackBar('Borrado exitosamente', 'Okay', 2000);
          } else {
            this._sharedService.ShowSnackBar('Error al eliminar', 'Okay', 2000);
          }
        }, err => {
          console.error(err);
          this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
        });
      }
    }
    )
  }

}

